// src/pages/Terms.jsx
import { Box, Heading, Text, VStack } from "@chakra-ui/react";
import PublicLayout from "../components/PublicLayout";
import { Helmet } from "react-helmet-async";

export default function Terms() {
  return (
    <PublicLayout>
      <Helmet>
        <title>Terms of Service | postcode.coupons</title>
        <meta
          name="description"
          content="Terms and conditions for using postcode.coupons."
        />
        <meta name="robots" content="noindex" />
      </Helmet>

      <Box maxW="800px" mx="auto" p={6}>
        <Heading mb={6} color="red.600">
          Terms of Service
        </Heading>

        <VStack align="start" spacing={6} fontSize="md" color="gray.800">

          <Text>
            These Terms govern your use of postcode.coupons (“the Service”).
            By creating an account or using the platform, you agree to these Terms.
          </Text>

          <Box>
            <Heading size="md" mb={2} color="black">1. Accounts</Heading>
            <Text>
              You must provide accurate information when creating a business account.
              You are responsible for maintaining the security of your login credentials.
            </Text>
          </Box>

          <Box>
            <Heading size="md" mb={2} color="black">2. Business advertising</Heading>
            <Text>
              Businesses may book advertising slots in Coupon Flyers. All content must
              comply with UK advertising standards and must not contain prohibited or
              misleading claims.
            </Text>
          </Box>

          <Box>
            <Heading size="md" mb={2} color="black">3. Payments</Heading>
            <Text>
              Payments are processed securely by Stripe. By booking a slot, you authorise
              us to charge your chosen payment method.
            </Text>
          </Box>

          <Box>
            <Heading size="md" mb={2} color="black">4. Refunds</Heading>
            <Text>
              Refunds are issued only if a Flyer fails to print or deliver due to our error.
              All other bookings are final.
            </Text>
          </Box>

          <Box>
            <Heading size="md" mb={2} color="black">5. Acceptable use</Heading>
            <Text mb={2}>You agree not to:</Text>
            <VStack align="start" pl={4} spacing={1}>
              <Text>• Upload harmful or illegal content</Text>
              <Text>• Attempt to bypass security features</Text>
              <Text>• Scrape or copy platform data</Text>
            </VStack>
          </Box>

          <Box>
            <Heading size="md" mb={2} color="black">6. Liability</Heading>
            <Text>
              The Service is provided “as is”. We are not liable for indirect, incidental,
              or consequential losses arising from your use of the platform.
            </Text>
          </Box>

          <Box>
            <Heading size="md" mb={2} color="black">7. Termination</Heading>
            <Text>
              We may suspend or terminate accounts that violate these Terms or pose a
              security or operational risk.
            </Text>
          </Box>

          <Box>
            <Heading size="md" mb={2} color="black">8. Contact</Heading>
            <Text>
              For legal enquiries, email: <strong>legal@postcode.coupons</strong>
            </Text>
          </Box>

        </VStack>
      </Box>
    </PublicLayout>
  );
}
